import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Container from './Container';
import Button from './Button';
import courseBg from '../images/fp-course-bg.jpg';

const CoursesContainer = styled(Container)`
  margin-top: 3rem;
  padding: 0;
  background: black;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("${courseBg}") no-repeat center center;
  background-size: cover;
  transition: transform ease-in-out 0.3s;
  opacity: 0.7;
`;

const Course = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 25rem;
  overflow: hidden;
  color: white;
`;

const Content = styled.div`
  position: relative;
  padding: 2rem 3rem;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
`;

const Description = styled.p`
  margin: 0;
`;

const StyledButton = styled(Button)`
  margin-top: 2rem;
  cursor: pointer;
`;

const Courses = () => (
  <CoursesContainer wide>
    <Course>
      <Background />
      <Content>
        <Title>Kurs programowania funkcyjnego</Title>
        <Description>
          W kursie poznasz czym są higher order functions, currying oraz w jaki
          sposób komponować funkcje.
        </Description>
        <Description>
          Nauczysz się jak operować na danych tworząc czysty i przewidywalny
          kod.
        </Description>
        <Link to="/programowanie-funkcyjne">
          <StyledButton>Zobacz kurs</StyledButton>
        </Link>
      </Content>
    </Course>
  </CoursesContainer>
);

export default Courses;
